export const locale = {
  lang: "fr",
  data: {
    Global: {
      rTicket: "Recherche ticket",
      ncs: "Pas de caractères spéciaux autorisés",
      vSuj: "Veuillez choisir un sujet",
      rec: "Réclamation",
      di: "Demande d'information",
      rem: "Remerciements",
      av: "Avis",
      success: "succès",
      info: "Information",
      err: "Erreur",
      tousS: "Tous les services",
      tnd: " DT",
      bonus: "Bonus",
      dt: " DT",
      boutonpd: "Plus de détails",
      opp: "Opérateur portabilité",
      oo: "Ooredoo",
      tt: "Tunisie Telecom",
      or: "Orange",
      valider: "Valider",
      org: "Organisme",
      ref: "Réference",
      montant: "Montant",
      mp: "Montant payé",
      env: "Envoyer",
      max: "Maximum",
      conf: "Confirmer",
      renv: "Renvoyer",
      ann: "Annuler",
      retourcnx: "Retour à la page connexion",
      retour: "Retour",
      continuer: "Continuer",
      passer: "Passer cette étape",
      suiv: "Suivant",
      payer: "Payer",
      rp: "Reçu de paiement",
      rt: "Reçu transaction",
      pnv: "Payer avec une nouvelle carte",
      mdp: "Mode de paiement",
      date: "Date",
      it: "ID transaction",
      dateOp: "Date opération",
      etat: "Etat",
      ea: "En attente",
      bonusg: "bonus gagné",
      pfc: "Points de fidélité collectés",
      sold: "Solde",
      msg: "Votre achat est récompensé, SPW vous remercie pour votre fidélité.",
      astuce: "SPW astuce !",
      rEmailActif: "Rendre principal",
      supportADisposition: "Notre support client est à votre disposition, en cas de besoin",
      desWallet1:
        "Le Wallet est votre portefeuille virtuel qui vous permet de gérer le solde de votre compte SPW en ligne.",
      desWallet2:
        "Envoyez et recevez de l'argent facilement et payez tous les services avec SPW Wallet",
      pts: "points",
      confirm: "Confirmation",
      confdemande: "Confirmer votre demande",
      resOp: "Résultat de l'opération",
      vRes: "Voir le résultat",
      choixMP: "Choisir un moyen de paiement",
      addBenf: "Ajout bénéficiaire",
      avis: "Partager votre avis",
      wlc: "Vous êtes bien connecté à SPW 🎉 , 👋 Bienvenue",
      tapmsg: "Veuillez taper votre message",
      pin: "PIN ajouté avec succès",
      msgcode: "Veuillez saisir au moins un code ou bien passer cette étape",
      mconf: "👋 Vous avez déjà confirmé votre Email ",
      tconf: "👋 Vous avez déjà confirmé votre Téléphone",
      imgmsg:
        "Nous acceptons les extensions (jpg, png et jpeg) et la taille  doit être inférieure à 5MO",
      paymsg: "Vous ne pouvez pas payer avec cette carte",
      wallmsg: "Vous ne pouvez pas payer avec le Wallet",
      editmsg: "Succès de la modification",
      gcb: "Cette carte est supprimée",
      rib: "Le RIB ne correspond à aucune banque, veuillez vérifier",
      editben: "Le bénéficiaire est modifié avec succès",
      tranmsg: "Saisissez le numéro et le montant",
      max50: "Le montant maximum est 50 DT",
      numinv: "Numéro de téléphone invalide",
      wallins: "Le solde de votre Wallet est insuffisant",
      fav: "Gérer l'affichage de vos services favoris sur la page d'accueil en cliquant sur l'étoile",
      notif: "Notifications",
      notif2: "Non lues",
      notif3: "Consulter tous",
      notif4: "No notifications found",
      param: "Paramètre",
      faq: "FAQ",
      deco: "Déconnexion",
      cb: "Compte bancaire",
      paym: "Paiement marchand",
      wsf: "Wallet SPW",
      aw: "Alimentation wallet par",
      cp: "Carte de paiement",
      vv: "Versement/virement",
      rev: "Un revendeur",
      pre: "Précédent",
      dastuce:
        "Souhaitez-vous enregistrer cette carte pour un paiement plus facile, rapide et sécurisé la prochaine fois?",
      pm: "Pas maintenant",
      enr: "Enregistrer",
      frais: "Frais",
      transuc: "La transaction a été correctement traitée",
      lcom: "Laisser un commentaire",
      com: "Commentaire",
      noter: "Noter",
      sms: "SMS",
      codeenv: "Enter le code envoyer au",
      codeenva: "Code envoyé au",
      codeenvnum: "Code envoyé au numéro",
      codee: "Entrer le code envoyé sur votre",
      mvs: "Les mouvements du Solde Avoir",
      dd: "Date début",
      df: "Date fin",
      nomv: "Aucun mouvement sur votre solde avoir",
      merci: "Merci pour votre achat",
      ta: "Transférer de l'argent",
      rbank: "Relevé identité bancaire",
      nvs: "Nouveau solde",
      infoB1:
        "Vous bénéficiez d'un Bonus SPW après l'achat de n'importe quel service sur notre plateforme",
      infoB2:
        "Le montant de ce bonus s'ajoute à votre solde Bonus SPW immédiatement après la confirmation du paiement.",
      infoB3:
        "Vous pouvez par la suite transférer votre solde Bonus vers votre solde Avoir et profiter de tous les services disponibles.",
      infoAvoir:
        "Le Solde Avoir représente la somme versée suite à un remboursement, à une compensation ou autre motif. Il vous permet ensuite de payer les services offerts par SPW",
    },
    Dash: {
      title1: "Mon Wallet",
      stnd: "Solde DT",
      da: "Dernière alimentation",
      dt: "Dernier transfert",
      alim: "Alimenter",
      tran: "Transférer",
      tiktak: "Tik Tak",
      dTiktak: "Acheter rapidement en deux clics grâce à notre nouveau service TIK TAK .",
      boutonTiktak: "Découvrir",
      titletran: "Transactions",
      dTran: "Mes dernières transactions",
      sfid: "Programme de fidélité",
      dtbonus: "bonus gagnés",
      tsoldeavoir: "Transférer vers solde avoir",
      soldeav: "Solde avoir",
      titlequick: "Transférer de l'argent à un autre wallet SPW",
      titlequick2: "Ajouter bénéficiaires",
      demwallet: "Demander un wallet",
      as: "Acheter sur SPW",
      std: "standard",
      pf: "points collectés",
      messolde: "Mes soldes",
      suivisolde: "Suivi Solde",
      sa: "statut actuel",
      qt1: "Le quota d'achat de services est de",
      qt2: "DT par jour",
      gservF: "Gérer vos services favoris",
      notif: "Notifications",
      sc: "Support client",
      trB: "Transfert Bonus vers Solde Avoir",
    },
    tiktak: {
      tiktak: "Tik Tak",
      title:
        "Le paiement se fait directement avec le solde de votre Wallet SPW : Cliquer PAYER.",
      title1: "Recharge téléphonique par transfert direct",
      title2: "Recharge téléphonique par carte de recharge",
      title3: "Paiement factures",
      msg1: "Vous allez faire un transfert direct de",
      msg2: "dt vers le numéro",
      payer: "Payer",
      recu: "recu",
      rautre: "Recharger un autre numéro",
      msg3: "Succès de l'opération",
      msg4: "Cliquer sur le reçu pour voir votre code de recharge ",
      msg5: "Vous allez acheter une carte de recharge téléphonique",
      msg6: "de valeur",
      tdtitle: "Transfert rapide",
      msg7: "Succès de l'opération de recharge télèphonique",
    },
    verf: {
      title:
        "Procéder à la confirmation de votre adresse mail et votre N° de téléphone pour vérifier votre compte",
      confM: "Confirmer mon E-mail",
      confM2: "E-mail confirmé",
      confT: "Valider mon téléphone",
      confT2: "Téléphone validé",
      verCompte: "Vérifier mon compte",
      d1: "Saisir le code reçu sur ",
      contenu1: "Modifier mon e-mail",
      contenu2: "Nouveau numero téléphone",
      desVer: "Vérifier mon compte et créer mon 1er wallet",
      des: "Vérifier votre identité et bénéficier d'un accès illimité à tous les services sur SPW",
      cj: "Cashin/Jour",
      mcj: "Maximum Cashout/Jour",
      ocj: "Operation Cashin/Jour",
      o: "opérations",
      mocj: "Maximum Operation Cashout/Jour",
      sw: "Solde Wallet",
      v: "Vérifié",
      enc: "En cours de traitement",
      rf: "Remplir le formulaire en ligne",
      oui: "Oui",
      non: "Non",
    },
    control: {
      champobli: "Champ obligatoire",
      min6: "Minimum 6!",
      min6c: "Minimum 6 caractères",
      max16: "Maximum 16!",
      invFormat: "Format incorrect!",
      min2: "Minimum 2!",
      max2: "Maximum 2!",
      montantinc: "Montant incorrect",
      mailob: "Email est obligatoire",
      mailv: "Saisissez une adresse email correcte",
      codeinc: "code incorrect",
      numinv: "Numéro invalide",
      piniden: "Les codes PIN doivent être identiques",
      patterPrenom: "Veuillez saisir un prénom valide",
      patterNom: "Veuillez saisir un nom valide",
      mdp: "Votre mot de passe doit comprendre au moins 8 caractères (un ensemble de chiffres et de lettres et au moins une lettre MAJ et MIN)",
      mdpinv: "Mot de passe invalide",
      mdpidn: "Les mots de passe doivent être identiques",
      mode: "Choisir le mode d’envoi du code",
      nomval: "Veuillez saisir un nom valide",
      pin6: "Le code PIN est de 6 chiffres",
      pininc: "PIN incorrect",
      max: "Montant maximum",
      min1dt: "Minimum 1 DT",
      min10dt: "Minimum 10 DT",
      dd: "Date début est obligatoire",
      df: "Date fin est obligatoire",
      opob: "Type de l'opération est obligatoire",
      rib: "Le RIB est de 20 chiffres",
      min4: "Minimum 4 caractère",
      min: "minimum",
      maxi: "maximum",
      inv: "invalid",
      dfsup: "Date fin doit être supérieur à la date début !",
      top: "Type de l'opération",
      cinv: "Code association invalide",
      c100m: "100 caractères maximum",
      mmin: "Montant minimum",
    },
    placeholder: {
      numtel: "Numéro de téléphone",
      mont: "Montant",
      numver: "Numéro versement",
      trVV: "Téléchargez le reçu de versement/virement",
      idw: "ID Wallet/Email du bénéficière",
      motiftran: "Motif de transfert",
      motiftran2: "Motif de transfert, laissez un message pour votre bénéficière",
      rib: "RIB",
      bank: "Banque",
      searchfav: "Recherche favori",
      numfav: "Numéro de téléphone",
      search: "Recherche",
      cm: "Code marchand",
      etq: "Etiquette",
      nmail: "Nouveau email",
      cP: "Code SMS",
      cM: "Code e-mail",
      mP: "Modifier Téléphone",
      davis:
        "Votre avis compte pour nous. N'hésiter pas d'envoyer une recommandation, un avis, une remarque, ect",
    },
    Connexion: {
      welcome: "Bienvenue sur SPW",
      msg1: "Connectez-vous à votre compte",
      dPIN2: "Votre sécurité est notre priorité, entrez votre PIN",
      msg3: "Nouveau sur SPW ?",
      msg4: "Créer un compte",
      pin: "PIN",
      pinoub: "Pin oublié??",
      cnx: "Connexion",
    },
    Inscri: {
      title: "L'aventure commence ici ",
      title2: "S'inscrire à SPW, c'est rapide et gratuit",
      dPIN: "Pour votre sécurité, Définissez un code PIN",
      errmsg1: "Vous avez déjà un compte sur SPW avec cette adresse email.",
      errmsg2: "Ce mail est déja utiliser.",
      title4: "Vous avez déjà un compte?",
      title5: "Connectez-vous",
      title6: "Ou s'inscrire avec",
      confpin: "Configuration PIN",
      condi: "conditions d'utilisation",
      condi2: "politique de confidentialité",
      et: "et",
      condi3: "politique de remboursement",
      condi4: "de SPW",
      ng: "Nom Gérant",
      pg: "Prénom Gérant",
      nummob: "Numéro de téléphone mobile",
      numfix: "Numéro de téléphone fixe",
      ns: "Nom Société",
      sd: "Secteur d'activité",
      fj: "Forme juridique",
      pp: "Personne physique",
      sarl: "SARL",
      sa: "SA",
      suarl: "SUARL",
      numi: "Numéro d'identité",
      numiinv: "Numéro d'identité invalid",
    },
    forgotPass: {
      rPW: "Réinitialisation du mot de passe",
      descMP:
        "Saisissez l'adresse e-mail et le numéro de téléphone associés à votre compte SPW",
      dPW: "Définissez votre nouveau mot de passe",
    },
    ResetPin: {
      rPIN: "Réinitialisation PIN",
      dPIN3: "Définissez votre nouveau code PIN",
    },
    Browsec: {
      sauv: "Enregistrer le navigateur",
      title: "Vérification d'indentité",
      title1:
        "Pour accéder à votre compte en toute sécurité, nous souhaitons vérifier votre identité",
    },
    vPIN: {
      title: "PIN",
      des: "",
    },
    Carte: {
      alimCarte: "Alimentation par carte",
      dAlimCarte: "Choisir le montant et la carte",
      Conf: "Confirmation",
      RS: "Résultat de l'opération",
      D1: "Alimenter votre Wallet SPW par carte en ligne et en toute sécurité ",
      desAlim:
        "Saisir le montant, choisir la carte que vous convient, valider le paiement et votre wallet SPW est rechargé immédiatement",
      aw: "Alimentation Wallet",
      rw: "Recharge Wallet",
      numver: "Numéro versement/virement",
      numc: "N° COMPTE",
    },
    Espece: {
      title1: "Recharge wallet par Versement/Virement",
      title2: "Liste des agences",
      AE: "Alimenter wallet en espèce",
      DAC: "Remplir le formulaire",
      Conf: "Confirmation",
      RS: "Résultat de l'opération",
      D1: "Vous n'avez pas une carte de paiement en ligne ! Cette solution est pour vous.",
      D2: "En espèce à travers nos comptes bancaire, vous pouvez effectuer  un versement/virement pour alimenter votre wallet SPW",
    },
    popRes: {
      title: "You are not authorized!",
      des: "",
      title2: "Verifier",
    },
    AccountSet: {
      title: "Informations personnelles",
      bouton: "Modifier",
      des: "Allowed JPG, GIF or PNG. Max size of 800kB",
      pmcp: "Paramètre du compte",
      vw: "Verification et wallet",
      nom: "Nom",
      prenom: "Prénom",
      dn: "Date de naissance",
      ville: "Ville",
      modifmdp: "Modifier mot de passe",
      modifpin: "Modifier PIN",
      modifmail: "Modifier mail",
      hismail: "Historique Mail",
      vpin: "Vérification PIN avec chaque transaction",
      cc: "Clôture compte",
      ancienpass: "Ancien mot de passe",
      vpass: "Nouveau mot de passe",
      cpass: "Confirmer mot de passe",
      ancienpin: "Ancien Pin",
      vmpin: "Nouveau Pin",
      cpin: "Confirmer Pin",
      ancientel: "Ancien numéro Téléphone",
      vtel: "Nouveau numéro Téléphone",
      mdp: "Mot de passe",
      numide: "Les numéros doivent être non identiques",
      scode: "SCode",
      mdpoub: "Mot de passe oublié?",
      ancienm: "Ancien Email",
      hemail: "Historique de changement Email",
      email: "Email",
      du: "Date utilisation",
      dm: "Date modification",
      vk: "Renseigner les informations manquements via ce formulaire pour avoir un Wallet SPW ",
    },
    Rev: {
      title:
        "Alimenter votre Wallet SPW chez les revendeurs SPW. Aller à la boutique la plus proche, déposer de l'argent en espèce pour une recharge instantanée.",
      rev: "Revendeurs",
      search: "Recherche revendeur",
    },
    CashOut: {
      title1: "Transfert d'argent vers un wallet SPW",
      wFav: "Wallets bénéficiaires favoris",
      tw: "Transfert d'argent vers wallet",
      dtw: "Remplir le formulaire",
      tvw: "Transfert vers wallet",
      d1: "Avec mon wallet, j'envoie de l'argent instantanément à un autre wallet SPW, où que je sois et quand je veux.",
      d2: "Remplir le formulaire, confirmer l'opération de transfert et le wallet de votre destinataire est alimenté immédiatement",
      dwf: "Un transfert d'argent plus facile ! Ajouter les wallets de vos proches dans la liste favori",
      title3: "Transfert d'argent vers un compte bancaire",
      title4: "Mes comptes bancaires",
      d3: "Demande de transfert d'argent",
      d4: "Un transfert d'argent sécurisé et garanti vers mon compte bancaire ! C'est notre engagement",
      mcb: "Gestion compte bancaires",
      addrib: "veuiller ajouter un rib pour faire un transfert bancaire",
      conftran: "Confirmez le transfert d’argent",
      addBenf1: "Ajouter un bénéficiaire à la liste favorite",
      nombenf: "Nom bénéficiaire",
      confdem: "Confirmer la demande transfert",
      addRIB: "Ajout compte bancaire",
      desAddR2: "Saisir le RIB et téléchargez l'identifiant bancaire",
      dmen: "Demande de transfert d’argent",
      vb: "Virement bancaire",
      dd: "Date demande",
      nbenf: "Nom bénéficier",
      rbenf: "RIB bénéficier",
      mwall: "Modifier un bénéficiaire",
      nomben: "Nom du bénéficiaire",
      vnomben: "Veuillez saisir un nom bénéficiaire valide",
      img: "image",
      title2: "Choisissez le solde à partir duquel vous souhaitez effectuer le transfert",
    },
    RechTel: {
      d1: "Une recharge téléphonique simple et récompensé ! C'est avec SPW",
      d2: "Insérer le numéro de téléphone et le montant, payer en toute sécurité, et votre ligne sera immédiatement rechargée",
      gmf: "Gérer mes favoris",
      d4: "Sélectionner votre carte de recharge de votre opérateur téléphonique, payer en toute sécurité, et recevoir votre code immédiatement.",
      cr: "Reçu de paiement",
      msg: "Votre achat est récompensé, SPW vous remercie pour votre fidélité.",
      rn: "Recharger de nouveau",
      codeRech: "Code de recharge",
      addFav: "Ajouter à la liste de favoris",
      gFav: "Gérer vos numéros favoris",
      daddFav: "Ajouter les numéros de vos proches à vos favoris pour une recharge plus rapide",
      td: "Transfert direct",
      vcr: "Votre code de recharge",
      v: "Valeur",
      adfav: "Ajouter un numéro favori",
      imgfav: "image favoris",
      add: "Ajouter",
      edfav: "Modifier le numéro favori",
      num8: "Numéro 8 chiffre",
      numTel: "Numero téléphone",
    },
    Marchand: {
      DES1: "Payer chez les marchands partenaires en toute sécurité via votre compte SPW et bénéficier des bonus et des promotions",
      DES2: "Découvrir la liste des meilleurs marchands qui acceptent SPW comme un moyen de paiement",
      DES3: "C'est parti ! Un paiement sécurisé et récompensé chez des partenaires avec SPW.",
      DES4: "Faire votre shopping et payer en toute sécurité.",
      DES5: "Besoin d'assistance ? N'hésitez à contacter notre service support.",
      dcc: "Sur les sites de nos marchands partenaires, une fois vous avez commandé un bien ou un service en choisissant de suivre le paiement avec SPW. Un code de paiement en ligne est généré pour identifier votre commande, c'est le Code Commande.",
      T1: "Paiement marchand",
      DT1: "Entrer le code commande",
      DT3: "Confirmer votre achat et payez ",
      T4: "Résultat de l'opération",
      DT4: "Voir le résultat d'achat",
      Contenu1: "Code commande",
      Contenu2: "Payer via code commande",
      BS: "Suivant",
      BV: "Verifier",
      BR: "Retour",
      ChampOb: "Champ obligatoire",
      Contenu3: "Ce code reste valide seulement",
      Contenu4: "minute",
      Contenu5: "Informations de la transaction",
      Contenu6: "Nom marchand",
      Contenu7: "Site marchand",
      Contenu8: "Montant",
      Contenu9: "Bonus",
      Contenu10: "Date de la transaction",
      DEXP: "DATE EXP",
      PNV: "Payer avec une nouvelle carte",
      POSTEinfo1: "E-Dinar Smart, Digicard",
      POSTEDinfo1: "Utilisez votre carte prépayée de la Poste",
      POSTEinfo2: "Visa Electron, DinarPost",
      POSTEDinfo2: "Utilisez votre carte Visa Electron ou DinarPost de la poste",
      invFormat: "Format incorrect!",
      DES6: "Un don, une vie ! Ouvrez votre cœur pour une association en lui faisant un don en ligne avec SPW, il suffit de cliquer sur l'association et suivre les instructions.",
      DES7: "Sans site e-Commerce, payez chez des boutiques physiques, virtuelles, sur les réseaux sociaux, des freelances, etc. avec le Code Marchand, l'identifiant du Marchand sur la plateforme SPW.",
      dT1: "Faire un don",
      dDT1: "Choisir une association",
      dDT3: "Confirmer votre achat et payez ",
      dT4: "Résultat de l'opération",
      dDT4: "Voir le résultat d'achat ",
      dContenu1: "Faire un don",
      dContenu2: "Choisir une association",
      cmT1: "Paiement marchand",
      cmDT1: "Entrer le code marchand",
      cmDT3: "Confirmer votre achat et payez ",
      cmT4: "Résultat de l'opération",
      cmDT4: "Voir le résultat d'achat ",
      cmContenu1: "Paiement marchand",
      cmContenu2: "Entrer le code marchand",
      rsite: "Retour vers le site marchand",
      pc: "Payer via code marchand",
      cmd: "Commander",
      mp: "Marchands partenaires",
    },
    fid: {
      title: "Votre fidélité est récompensée",
      subtitle: "La meilleure formule pour vous dire Merci ! Est notre programme de fidélité",
      subtitle2: "Gagnez des points à chaque achat, cumulez et obtenez des récompenses.",
      d1: "Passer d'un statut au suivant et gagner davantage.",
      d2: "Profiter avec SPW, vos achats sont récompensés",
      pd: "Plus de détails sur le programme de fidélité",
      sValide: "Statut validé",
      sActuel: "Statut actuel",
      sSuivant: "Statut suivant",
      sVerouille: "Statut verrouillé",
      fid7: "La meilleure formule pour vous dire Merci ! Est noter programme de fidélité",
      fid8: "Pour récompenser votre fidélité, SPW vous offre sur chaque achat des points de fidélité cumulables, vous permettant de progresser dans le statut et donc les avantages et les récompenses évoluent avec chaque passage",
      sysProg: "Système de progression",
      prog1:
        "Nous proposons 5 statuts de fidélité, Standard, Silver, Gold, Diamant et VIP, ci-dessous les règles pour passer d'un statut à un autre",
      prog2:
        "Pour débloquer un Statut, il suffit de collecter un nombre de points dans un intervalle de date bien déterminé",
      nbPoints: "Nombre de points à collecter",
      intervalleDate: "Intervalle de date en jours",
      sysCollecte: "Système de collecte de points",
      coll1:
        "Suite à vos achats, vous pouvez cumuler vos points rapidement en suivant le barème suivant",
      valUni: "Valeur unitaire en DT",
      ptsaG: "Points à gagner",
      sysRec: "Système de récompense",
      sysRec1:
        "Différentes façons pour récompenser votre fidélité,  différentes façons pour vous dire Merci !",
      sysRecul: "Système de recul",
      sysRecul1:
        "Je peux perdre mes points même mon statut ! Malheureusement c'est possible. Restez fidèle et vous ne perdrez rien.",
    },
    mdp: {
      cr: "Carte de recharge",
      sc: "Sélectionner une carte",
      mdp: "Mode de paiement",
      cp: "Confirmation et paiement",
      cap: "Confirmer votre achat et payez",
      ro: "Résultat de l'opération",
      vro: "Voir le résultat d'achat",
      op: "Opération",
      tvcb: "Transfert vers un compte bancaire",
      Conf: "Confirmation",
      r: "Resultat",
      ra: "Resultat d'achat",
    },
    recu: {
      srv: "Service",
      scr: "Recharge téléphonique par Carte",
      ds: "Détails Service",
      op: "Opérateur",
      md: "Montant demandé",
      com: "Commission",
      bonus: "Bonus",
      pf: "Points fidélité",
      tap: "Total à payer",
      rem: "Remise",
      nm: "Nom marchand",
      sm: "Site marchand",
      p: "pts",
      map: "Montant à payer",
      ns: "Numéro de série",
      dt: "Détails transaction",
      tsw: "Transfert solde vers wallet",
      mexp: "Email de l'expéditeur",
      mrec: "Email du récepteur",
      dp: "Date paiement",
      numCpt: "Numéro de compte",
      portC: "Porteur du compte",
      fraisInt: "Frais international",
      nomP: "Nom partenaire",
      codeP: "Code de paiement",
      numCarte: "Numéro carte",
      refPaie: "Référence de paiement",
      idwBene: "ID Wallet bénéficiaire",
      numR: "Numéro rechargé",
    },
    faq: {
      title: "Nous sommes là pour vous aider!",
      subtitle:
        "Choisir une catégorie vous permettra de trouver des réponses plus rapidement et facilement",
      search: "Recherche",
      aucres: "Aucun résultat trouvé",
      title2: "Avez-vous d'autres questions?",
      subtitle2:
        "N'hésitez pas à nous contacter si vous avez des questions. Nous sommes toujours heureux de vous aider",
      box1: "Contacter support client",
      box2: "Téléphone",
      box3: "E-mail",
      box4: "Adresse",
      box5: "Horaire",
      resoc: "Nos réseaux  sociaux",
      j1: "Lundi - Vendredi",
      j2: "Samedi",
    },
    conso: {
      title: "Consommmation",
      display: "Afficher",
      cw: "Cashin wallet",
      ea: "Expand All",
      ca: "Collapse All",
      caw: "Cashout wallet",
      ssf: "Services SPW",
      pdc: "Pas de consommation pendant cette période",
      totalRc: "Total opérations d'alimentation wallet",
      totalTr: "Total opérations de transfert d'argent depuis le wallet",
      totalSer: "Total services achetés sur SPW market",
      dont: "dont",
    },
    DocCarteRech: {
      cr1: "Recharge téléphonique avec une carte de recharge",
      cr2: "Bénéficier de l'un des services de votre quotidien en quelques clics, des bonus et des points de fidélités sont offerts avec chaque achat.",
      cr3: "Suivez les étapes ci-dessous pour acheter un code de recharge",
      cr4: "Choisir l'opérateur et la valeur de votre code de recharge",
      cr5: "Choisir le mode de paiement qui vous convient et valider",
      cr6: "Vous recevez le code de recharge immédiatement après le paiement au niveau de la page résultat",
      cr7: "Cliquez sur «Code de recharge» et utilisez le code que vous avez reçu pour recharger votre solde",
      cr8: "Méthode de la recharge du code sur votre mobile",
      cr9: "*101*Code de recharge#",
      cr10: "*100*Code de recharge#",
      cr11: "*123*Code de recharge#",
      infoService: "Information sur le service",
      fiscal:
        "La majoration de prix de la carte de recharge représente les droits de timbre fiscal imposé par la loi tunisienne",
      crPerdu:
        "Si vous avez perdu votre code de recharge ou la page de paiement ne s'affiche pas, vous pouvez consulter votre ticket dans l'historique des transactions sous la rubrique « Mes transactions »",
    },
    DocRechTel: {
      td1: "Recharge téléphonique avec un transfert direct",
      td2: "Bénéficier de l'un des services de votre quotidien en quelques clics, des bonus et des points de fidélités sont offerts avec chaque achat.",
      td3: "Suivez les étapes ci-dessous pour recharger votre solde.",
      td4: "Insérer le numéro de téléphone et le montant de recharge.",
      td5: "Choisir le mode de paiement qui vous convient et validez.",
      td6: "Le montant que vous avez demandé sera transféré à votre ligne téléphonique immédiatement après le paiement.",
      td7: "Pour les recharges Ooredoo Light, TTcash et Orange Express la valeur du timbre fiscal sera prélevée du montant rechargé (14%).",
      td8: "Un SMS sera envoyé par l'opérateur au bénéficiaire pour confirmer le succès de l'opération de recharge.",
    },
    DocEspece: {
      cashInEspHeader: "Alimentation wallet SPW en espèce par versement/virement",
      cashInEsp1:
        "Avec le versement/virement vous pouvez alimenter votre solde SPW et effectuer plusieurs opérations d'achat sans passer par le paiement par carte bancaire ou carte prépayée de la poste.",
      cashInEsp2: "Suivez les étapes ci-dessous pour recharger votre wallet par versement/virement",
      cashInEsp3: "Rendez-vous à l'une des agences bancaires ou bien l'agence de la poste",
      cashInEsp4:
        "Déposer le montant que vous voulez utiliser sur SPW sur le compte de la société HAMTEL.",
      cashInEsp5: "Après le dépôt, vous trouverez le numéro de versement affiché sur le reçu.",
      cashInEsp6:
        "Rendez-vous à la rubrique d'alimentation wallet en espèce sur SPW.tn et remplissez le formulaire de la demande correctement.",
      cashInEsp7:
        "Après la validation de votre demande par nos administrateurs, votre compte SPW sera crédité après peu de temps par la somme que vous avez demandée.",
    },
    DocWallet: {
      interw1:
        "Vous pouvez envoyer (ou recevoir) de l'argent à (ou de) un wallet d'un proche instantanément, en toute sécurité et sans frais supplémentaires. Le destinataire doit être inscrit sur SPW.tn pour bénéficier de ce service.",
      interw2: "Suivez les étapes ci-dessous pour recharger un autre wallet sur SPW",
      interw3: "Saisir ID Wallet ou Email du bénéficiaire et le montant à transférer.",
      interw4: "Laisser un message pour votre destinataire ! Si vous souhaitez.",
      interw5: "Valider l'opération et le wallet de destinataire ets alimenté instantanément.",
      interw6:
        "Astuce avec SPW pour simplifier votre navigation ! Pas besoin de chercher l'email ou ID Wallet de votre bénéficiaire avec chaque opération de transfert, ajouter donc les wallets de vos proches comme favoris",
    },
    en: {
      title: "Anglais",
    },
    fr: {
      title: "Francais",
    },
    ar: {
      title: "Arabe",
    },
    da: {
      title: "Dialecte",
    },
    trans: {
      title: "Mes transaction",
      search: "Recherche transactions",
      idt: "ID-Transaction",
      det: "Détails",
      auctran: "Aucune transactions touvée",
    },
    supp: {
      title: "Souhaitez-vous fermer ce ticket ?",
      txt: "Si vous confirmez cette opération, le ticket sera définitivement fermé.",
      btn1: "Oui, je confirme",
      btn2: "Annuler",
      nt: "Nouveau ticket",
      t: "Tickets",
      tn: "Ticket n°",
      not: "Aucun ticket créé",
      mr: "Mes réclamations",
      vm: "Votre message",
      af: "Ajouter un fichier",
      fr: "Fermer la réclamation",
    },
    marchext: {
      title: "Saisissez vos informations pour suivre le paiement",
      it: "Information transaction",
      dt: "Date transaction",
      bsf: "Bonus SPW",
      adv: "Quels sont les avantages de paiement avec SPW?",
      paysf: "Pourquoi payer via un compte SPW !",
      db: "Des bonus",
      sr: "Système de remboursement",
      sd: "Support dédié",
      mvf: "Merci pour votre fidélité",
      vcc: "Votre code commande",
      att: "Attention le code est valide pour seuelement",
      prg: "Vous pouvez utiliser le code commande pour finaliser la procèdure de paiement ou donner le code à un de vos proches pour faire le paiement à votre place ",
      pexp: "Paiement Express",
      sp: "Succès de paiement",
      inscsf: "S’inscrire sur SPW",
      cn: "Se connecter",
      p1: "Votre paiement a été effectué avec succès auprès du marchand",
      rec: "Veuillez trouver ci-dessous votre reçu",
      fq: "Facilitez votre vie quotidienne avec SPW",
      rt: "Recharge téléphonique",
      ta: "Transfert d'argent",
      dsf: "Découvrir SPW",
      sc: "Service client",
    },
    bloc: {
      title: "Demande de justificaction",
      dtitle: "Votre compte SPW est momentanément bloqué",
      d1: "Carte d'identité vue de face",
      d2: "Carte d'identité vue de face avant",
      cimg: "Choissisez une image",
      d3: "Carte d'identité ou passport avec votre visage",
      d4: "Carte d'identité ou passport avec votre visage",
      d5: "Extrait bancaire",
      d6: "Carte bancaire face avant",
      title2: "Vérification Téléphonique",
      dtitle2: "Merci d'entrer le code de validation que vous avez recu par SMS",
      sno: "Service non autorisé",
      dsno: "Procéder à la vérification de votre compte pour bénéficier de ce service",
      dsno2:
        "Procéder à la confirmation de votre compte via votre page d’accueil pour bénéficier de ce service.",
    },
    qt: {
      title: "Transfert d'argent vers autre Wallet SPW",
      p1: "Vous êtes sur le point de transférer",
      p2: "depuis votre wallet vers le wallet de ",
      id: "ID",
      p3: "Une fois, vous validez, le montant sera débité directement de votre wallet SPW",
      vt: "Valider le transfert",
      p4: "Le transfert de ",
      p5: "a été effectué avec succès vers le Wallet bénéficiaire",
    },
    cloture: {
      title: "Clôturer votre compte SPW et supprimer vos données",
      p1: "Si vous avez besoin d'aide avant de fermer définitivement votre compte SPW, veuillez nous contacter à travers le lien suivant",
      nc: "Contactez-nous",
      p2: "Une fois ce compte clôturé, toutes vos données seront supprimées. Vous ne pourrez plus l'utiliser ni le rouvrir, mais vous pouvez vous inscrire de nouveau pour ouvrir un autre compte.",
      rc: "Raison de clôture",
      min8: "Minimum 8 character",
      cc: "Clôturer le compte",
      q: "Souhaitez-vous vraiment clôturer votre compte SPW définitivement ?",
    },
    gcb: {
      nocarte: "Aucune carte enregistrer",
      title: "Vous devez enregistrer une carte lors de paiement avec carte bancaire",
      ac: "Activer carte",
      dc: "Désactiver carte",
      sc: "Supprimer carte",
    },
    popst: {
      title: "CONGRATULATION !",
      title2: "Nouveau statut de fidélité",
      title3: "SPW vous offre des points cadeaux",
      title4: "Nous vous remercions pour votre fidélité",
    },
    tw: {
      tw: "Transfert d'argent vers wallet SPW",
      tnv: "Transférer de nouveau",
      mpin: "Modification PIN",
      confpin: "Confirmer l'opération avec votre PIN",
    },
    docBank: {
      title: "Virement Bancaire",
      d1: "Avec le service de Virement Bancaire vous pouvez demander de transférer votre solde sur la plateforme SPW vers votre compte bancaire justifié.",
      d2: "C’est quoi un compte bancaire justifié?",
      d3: "C’est un compte bancaire qui respecte les conditions ci-dessous:",
      d4: "Le compte bancaire doit impérativement avoir le même nom que celui de votre compte SPW sinon votre demande sera rejetée.",
      d5: "Avant de valider votre premier transfert, vous devez nous envoyer le fichier de votre identifiant bancaire ou extrait bancaire contenant un RIB lisible et claire.",
      d6: 'A qui s’adresse le service "transfert vers compte bancaire"?',
      d7: "Tous les utilisateurs vérifiés sur la plateforme SPW.tn",
      d8: "Ajouter compte",
      d9: 'Cliquer sur le bouton "+".',
      d10: "Remplir le formulaire d’ajout.",
      d11: "Télécharger le fichier de votre identifiant bancaire ou extrait bancaire.",
      d12: "Cliquer sur valider pour envoyer votre demande d’ajout.",
      d13: "Comment effectuer un transfert vers un compte bancaire?",
      d14: "Tous les inscrits vérifiés sur SPW.tn peuvent, à partir de la rubrique «Virement bancaire» effectuer un transfert de solde de leur compte SPW vers leur compte bancaire. Il suffit de suivre les étapes ci-dessous :",
      d15: "Saisir le montant à transférer en DT (Minimum 20 DT et Maximum 3000 DT)",
      d16: "Entrer le RIB (série de 20 chiffres).",
      d17: "Choisir la banque qui correspond au RIB.",
      d18: 'Valider le transfert en cliquant sur "Envoyer".',
      d19: "Le traitement de votre demande prend quelques jours.",
      d20: "Vous pouvez faire un virement bancaire que si et seulement si votre solde SPW est supérieur ou égal au montant à payer (Montant avec commission).",
      d21: "Si vous avez une demande de virement bancaire en cours de traitement, vous ne pouvez pas envoyer une autre demande de virement.",
      d22: "Combien ça me coûte?",
      d23: "La commission appliquée pour ce service est de 2DT.",
      d24: "Les avantages d’un virement bancaire en ligne sur SPW:",
      d25: "Retirer votre solde SPW à partir de votre agence ou carte bancaire",
      d26: "Bénéficier d’un transfert en ligne sécurisé, instantané et accessible à tout moment (24/24 et 7/7)",
    },
    docM: {
      title: "Paiement marchand",
      d1: "C’est quoi le paiement marchand ?",
      d2: "Service de paiement en ligne est un ensemble d’opérations dématérialisées mises à la disposition des utilisateurs de SPW.tn, leur permettant le règlement des achats effectués sur un site de commerce électronique partenaire de SPW. Ce règlement se fait via le compte SPW de manière sécurisée.",
      d3: "Fonctionnement du Service :",
      d4: "Après avoir validé votre panier sur le site marchand et choisi le mode de paiement par SPW vous pouvez payer en utilisant les deux méthodes ci-dessous :",
      d41: "1ère méthode :",
      d5: "Vous renseignerez un formulaire en rentrant des informations tel que votre email, mot de passe ou votre numéro de téléphone associé à votre compte SPW. Vous serez ensuite redirigé vers le formulaire de validation paiement pour choisir le moyen avec lequel vous souhaiterez payer : Carte bancaire nationale ou internationale, carte e-DINAR de la poste ou par votre Solde SPW.",
      d42: "2éme méthode :",
      d6: "Chaque transaction de paiement marchand est identifiée par un code de paiement et chaque marchand est identifié par un code marchand que vous pouvez utiliser lors de la validation du paiement en accédant à votre compte SPW sous la rubrique paiement marchand.",
      d7: "Une fois le paiement validé vous ne pouvez plus annuler la transaction.",
      d8: "Le paiement du marchand est validé instantanément et le processus de livraison est activé immédiatement.",
      d9: "Si vous avez perdu le code de paiement vous pouvez le récupérer à partir de l’historique des transactions « paiement marchand ».",
      d10: "Le code de paiement reste valide seulement 60 minutes. Au-delà de ce délai, l’utilisateur ne peut plus payer avec ce code et doit passer une autre commande sur le site marchand.",
      d43: "Exécution du paiement :",
      d11: "Les montants à régler mentionnés sur le Site marchand sont indiqués en Dinar Tunisien (DT) toutes taxes comprises, et sont valables au moment de leur consultation par le client. Le règlement sera pris en compte immédiatement par le système. En cas d’indisponibilité de ce dernier, vous en serez informé et votre règlement ne sera pas pris en compte. Vous pourrez reprendre le paiement ultérieurement.",
      d44: "Le paiement :",
      d12: "Pour effectuer un paiement, vous devrez choisir SPW comme mode de paiement en cliquant sur le bouton prévu à cet effet. Votre paiement par le service SPW est géré auprès de la Sté HAMTEL qui offre un service de paiement entièrement sécurisé. Vous garantissez à SPW que vous disposez des autorisations éventuellement nécessaires pour utiliser le mode de paiement choisi, lors de la validation de votre demande de paiement. Vous déclarez à cet effet, que vous êtes le titulaire légitime du compte SPW utilisé pour le paiement en ligne et que vous en assumez toutes les conséquences dans le cas contraire.",
      d13: "Protection et droit de l’utilisateur :",
      d14: "Délai de livraison :",
      d15: "Le vendeur ou le site marchand doit vous livrer le bien ou exécuter le service à la date indiquée lors de la commande. Si aucune date n’a été fixée lors de la commande, la livraison du bien ou l’exécution du service doit avoir lieu au plus tard 1 Mois après la commande.",
      d16: "En cas de non-respect du délai de livraison, vous pouvez annuler votre commande en envoyant une demande à partir de votre compte SPW.",
      d17: "Délai de remboursement :",
      d18: "Si vous retournez le bien au marchand partenaire de SPW ou annulez la prestation de service après avoir annulé votre commande en raison du non-respect du délai de livraison ou si le produit que vous avez acheté auprès du site marchand présente un défaut de conformité après la livraison:",
      d19: "Il est impropre à l’usage habituellement attendu d’un bien semblable..",
      d20: "Il ne correspond pas à la description donnée par le vendeur (par exemple, la couleur ne correspond pas au modèle présenté).",
      d21: "Il ne possède pas les qualités annoncées par le vendeur (par exemple, un appareil présenté comme particulièrement silencieux qui s’avère bruyant).",
      d22: "Vous devez être remboursé dans un délai de 1 Mois maximum. Toutefois, le marchand peut différer le remboursement jusqu’au jour de récupération des biens ou jusqu’à ce que vous ayez fourni une preuve d’expédition des biens.",
      d23: "Le marchand doit vous rembourser la totalité des sommes que vous avez versées, frais de livraison inclus.",
      d24: "En cas de non-respect du délai de livraison, vous pouvez annuler votre commande en envoyant une demande à partir de votre compte SPW.",
      d25: "Droit au Bonus :",
      d26: "Chaque utilisateur aura un Bonus sur les achats effectués auprès des marchands partenaires de SPW. Il s’agit d’un pourcentage déduit du montant de la transaction d’achat et ajouté au solde Bonus de l’utilisateur:",
      d27: "Le Bonus accordé à l’acheteur n’est pas fixe et dépend du marchand ou service sur SPW et sera affiché avant l’exécution de chaque paiement.",
      d28: "Le marchand partenaire de SPW peut ne pas accorder des Bonus aux acheteurs pour certains ou tous les articles ou services offerts sur sa boutique.",
      d29: "La validation du paiement par l’utilisateur signifie l’acceptation du prix et du Bonus relatifs à l’article ou service proposé par le marchand ou par SPW.",
      d30: "Le client SPW ne peut utiliser le Bonus et le transférer au solde SPW que si le solde Bonus dépasse 5DT (Cinq Dinars Tunisiens).",
      d31: "Vous pouvez transférer votre solde Bonus seulement vers votre solde SPW.",
      d32: "Si le paiement a été annulé ou le client a été remboursé, le montant du Bonus relatif à la transaction annulée sera déduit du solde Bonus du client.",
      d33: "Si le solde Bonus est inférieur au montant du Bonus relatif à la transaction annulée, ce dernier sera déduit du montant total ou partiel de la transaction annulée avant le remboursement du client.",
      d34: "Les avantages d’un paiement marchand par SPW :",
      d35: "Vous pouvez payer n’importe quel marchand (physique ou virtuel) partenaire de SPW.",
      d36: "Vous bénéficiez toujours d’un bonus après chaque paiement marchand.",
      d37: "Service hautement sécurisé et instantané.",
      d38: "Remboursement immédiat en cas de problème.",
      d39: "SPW protège ses utilisateurs des problèmes d’arnaque ou de non respect des délais de livraison pour tous les paiements en ligne effectués avec leurs comptes SPW.",
      d40: "Une solution facile à utiliser et accessible à tout moment (24/24 et 7/7).",
    },
    pays: {
      Ariana: "Ariana",
      Beja: "Beja",
      BenArous: "Ben Arous",
      Bizerte: "Bizerte",
      Gabes: "Gabes",
      Gafsa: "Gafsa",
      Jendouba: "Jendouba",
      Kairouan: "Kairouan",
      Kasserine: "Kasserine",
      Kebili: "Kebili",
      Kef: "Kef",
      Mahdia: "Mahdia",
      Manouba: "Manouba",
      Medenine: "Medenine",
      Monastir: "Monastir",
      Nabeul: "Nabeul",
      Sfax: "Sfax",
      SidiBouzid: "Sidi Bouzid",
      Siliana: "Siliana",
      Sousse: "Sousse",
      Tataouine: "Tataouine",
      Tozeur: "Tozeur",
      Tunis: "Tunis",
      Zaghouan: "Zaghouan",
      Autre: "Autre",
      tt: "Toutes les villes",
      t: "tous",
    },
    listserv: {
      title: "Les services proposés par la boutique ",
      t2: "",
      des: "Pour acheter, cliquez sur le service souhaité et suivez le processus d'achat avec le mode de paiement SPW.",
    },
  },
};
